module.exports = __webpack_public_path__ + "static/img/logo.5800ff83.svg";